import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'front-end-insert-quote-drafted-modal',
  templateUrl: './insert-quote-drafted-modal.component.html',
  styleUrls: ['./insert-quote-drafted-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsertQuoteDraftedModalComponent {
  constructor(private modalController: ModalController) {}

  close() {
    this.modalController.dismiss();
  }
}
